import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';


const SideBarHeader = ({ isMenuOpen, setIsMenuOpen, handleNewChat }) => {
    const theme = useTheme();
    return (
        <Grid
            sx={{
                width: "inherit",
                padding: "5px",
                display: "flex",
                flexWrap: "nowrap",
                gap: "10px",
            }}
        >
            <Grid
                sx={{
                    width: "inherit",
                }}
            >
                <Button
                    sx={{
                        width: "100%",
                        backgroundColor: theme.palette.primary[50],
                    }}
                    startIcon={<BorderColorIcon fontSize="small" />}
                    onClick={handleNewChat}
                >
                    New Chat
                </Button>
            </Grid>
            <Grid>
                <IconButton sx={{padding: '10px'}}    
                  onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <Tooltip title="Close Sidebar">
                        <MenuOpenIcon
                            fontSize="small"
                            sx={{ color: theme.palette.primary[500] }}
                       
                        />
                    </Tooltip>
                </IconButton>
            </Grid>
        </Grid>
    );
}

export default SideBarHeader;